/**
 * A generic toggle that controls another element's visibility
 *
 * sample usage:
 *
 * <button class="js-toggle" data-toggle-target="my-element">Toggle</button>
 * <div id="my-element" class="hidden">I am initially hidden</div>
 *
 * If you want to toggle only once and hide the button afterwards, use:
 *
 * <button class="js-toggle" data-toggle-target="my-element" data-toggle-hide-self>Toggle</button>
 * <div id="my-element" class="hidden">I am initially hidden</div>
 */
class Toggle {

  /**
   * Handles toggling another element's visibility when toggle element is clicked
   *
   * @param {HTMLElement} el Element to wrap.
   */
  constructor(el) {
    this.element = el;
    el.addEventListener('click', this.onClick);
  }

  /**
   * Handles toggling another element's visibility when toggle element is clicked
   *
   * @param {Event} e - Event object
   */
  onClick = (e) => {
    const toggle = e.currentTarget;

    if(toggle.dataset.toggleTarget) {
      const target = document.getElementById(toggle.dataset.toggleTarget);

      if(target) {

        target.classList.toggle('hidden');
        toggle.classList.toggle('is-toggled');
        if(typeof toggle.dataset.toggleHideSelf !== 'undefined') {
          toggle.classList.add('hidden');
        }

        // Show/hide content in toggle button based on current state
        const toggleContent = toggle.querySelectorAll('.js-toggle__toggle');
        const isToggledContent = toggle.querySelectorAll('.js-toggle__is-toggled');
        if (toggle.classList.contains('is-toggled')) {
          toggleContent.forEach(el => el.classList.add('hidden'));
          isToggledContent.forEach(el => el.classList.remove('hidden'));
        }
        else {
          toggleContent.forEach(el => el.classList.remove('hidden'));
          isToggledContent.forEach(el => el.classList.add('hidden'));
        }

        // custom logic for accordion icon rotate and other styling
        if (target.classList.contains('hidden')){
          toggle.removeAttribute('open')
        } else {
          toggle.setAttribute('open', true)
        }
      }
    }
  }
}

export default Toggle;
